import Header from "../../Profile/components/Header";
import PaymentFlow from "./PaymentFlow";

function Payments() {
	return (
		<>
			<Header />
			<div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
				<PaymentFlow />
			</div>
		</>
	);
}

export default Payments;
